import React from 'react';
import PropTypes from 'prop-types';
import { MaterialIcon } from '@pearsontechnology/aero-components';
import { FormattedMessage } from 'react-intl';

import {
  HeaderWrapper,
  Title,
  TextWrapDescription,
  BackButton,
} from './styles';

import messages from './messages';

const PluginSelectionHeader2ndStep = ({ title, description, descriptionValues, onBack }) => (
  <HeaderWrapper>
    <BackButton onClick={onBack}>
      <MaterialIcon id="arrow_back" />
      <span style={{ textTransform: 'uppercase' }}><FormattedMessage {...messages.backButton} /></span>
    </BackButton>
    <Title>
      <FormattedMessage {...title} />
    </Title>
    <TextWrapDescription>
      <FormattedMessage {...description} values={descriptionValues} />
    </TextWrapDescription>
  </HeaderWrapper>
);

PluginSelectionHeader2ndStep.propTypes = {
  title: PropTypes.object,
  description: PropTypes.object,
  descriptionValues: PropTypes.object,
  onBack: PropTypes.func,
};

export default PluginSelectionHeader2ndStep;
